import { Component, Inject, OnInit } from '@angular/core';
import { CustomerService } from '@app/services/customer.service';
import { first } from 'rxjs/operators';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-customer-api-testing',
  templateUrl: './customer-api-testing.component.html',
  styleUrls: ['./customer-api-testing.component.scss']
})
export class CustomerApiTestingComponent implements OnInit {

  public result = '';

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment, private customerService: CustomerService) { }

  ngOnInit() {
  }

  parseResult(response: HttpResponse<any>) {
    let body = response.body;
    if (Array.isArray(body)) { body = body.join('\r\n'); }
    if (body === null) { body = ''; }
    this.result = `HTTP ${response.status} ${response.statusText}\r\n\r\n${body}`;
  }

  parseError(response: HttpErrorResponse) {
    const err = response.error ? response.error : '';
    this.result = `HTTP ${response.status} ${response.statusText}\r\n\r\n${err}`;
  }

  // BB6B6878-C92B-4FCA-A033-B82293196404
  getAllTemplate() {
    this.result = 'Loading...';
    this.customerService.getAllTemplates().pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  getLibraryUrl() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('getLibraryUrl-workSiteId')).value;
    const templateName = (<HTMLInputElement>document.getElementById('getLibraryUrl-templateName')).value;
    this.customerService.getLibraryUrl(workSiteId, templateName).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  getSiteUrl() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('getSiteUrl-workSiteId')).value;
    this.customerService.getSiteUrl(workSiteId).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  getAppliedTemplates() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('getAppliedTemplates-workSiteId')).value;
    this.customerService.getAppliedTemplates(workSiteId).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  getProvisioningStatus() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('getProvisioningStatus-workSiteId')).value;
    this.customerService.getProvisioningStatus(workSiteId).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  createSite() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('createSite-workSiteId')).value;
    this.customerService.createSite(workSiteId).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

  applyTemplate() {
    this.result = 'Loading...';
    const workSiteId = (<HTMLInputElement>document.getElementById('applyTemplate-workSiteId')).value;
    const templateName = (<HTMLInputElement>document.getElementById('applyTemplate-templateName')).value;
    this.customerService.applyTemplate(workSiteId, templateName).pipe(first()).subscribe({
      next: data => this.parseResult(data),
      error: error => this.parseError(error),
    });
  }

}
